import { render, staticRenderFns } from "./AnotadosMesaExamenLista.vue?vue&type=template&id=dec70cf2&"
import script from "./AnotadosMesaExamenLista.vue?vue&type=script&lang=js&"
export * from "./AnotadosMesaExamenLista.vue?vue&type=script&lang=js&"
import style0 from "./AnotadosMesaExamenLista.vue?vue&type=style&index=0&id=dec70cf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports